export default __webpack_public_path__ + "static/media/application-icon-complete.53d4a89b.svg";